import router from '@/router';
import store from '@/store';
import { AxiosError } from 'axios';
import { StatusCode, ActionType, Routes, EventType } from '@/constants';
import { bus } from '@/main';
import { generateNewToken, source } from './base';
import { hideLoader } from '@/util';
import { signOut } from '@/core';

export const routeUpdate = (name: string) => {
  router.push({ name }).catch(() => {
    // suppress Vuejs Console Warining when Route override
  });
}

const showErrorPage = (errorCode: number) => {
  bus.$emit(EventType.ERROR, errorCode);
}

export const currentPath = (name: string) => {
  return router.currentRoute.name?.includes(name);
}
const handleErrorStatus = async (code: number) => {
  switch (true) {
    case code === StatusCode.UNAUTHORIZED:
      store.dispatch(ActionType.UPDATE_SIGNIN_STATUS, false);
      await signOut();
      !currentPath(Routes.SIGNIN) && routeUpdate(Routes.SIGNIN);
      break;
    case code === StatusCode.NOTFOUND:
      if (!store.getters.notFound) {
        source.cancel()
        generateNewToken();
        await store.dispatch(ActionType.UPDATE_NOT_FOUND_STATUS, true);
        !currentPath(Routes.SELECT_HOME) && routeUpdate(Routes.SELECT_HOME);
      }
      break;
    case code >= StatusCode.ISE:
      showErrorPage(StatusCode.ISE);
      break;
    case code >= StatusCode.BADREQUEST:
      showErrorPage(StatusCode.BADREQUEST);
      break;
    default:
      throw new Error();
  }
};

const handleAxiosError = (error: AxiosError) => {
  hideLoader();
  if (error.response) {
    handleErrorStatus(error.response.status);
  } else if (error.request) {
    handleErrorStatus(error.request.status);
  } else {
    throw new Error(error.message);
  }
}

export { handleAxiosError };
